var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMailDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.759 3H17.24c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392.753.383 1.3.811 1.684 1.564.098.192.012.433-.165.556l-.806.562c-.035.018-.07.04-.102.063l-8.165 5.715c-.73.51-.884.599-1.02.633a1 1 0 01-.484 0c-.136-.034-.29-.123-1.02-.633L2.573 6.181a1.009 1.009 0 00-.126-.075l-.78-.545C1.486 5.437 1.4 5.194 1.5 5c.383-.753.931-1.18 1.684-1.564.485-.247 1.002-.346 1.564-.392C5.29 3 5.954 3 6.758 3z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.399 9.341l-6.106 4.275c-.544.382-1.023.718-1.567.854a3 3 0 01-1.452 0c-.544-.136-1.023-.472-1.567-.854l-4.55-3.185v.002L1.742 8.055c-.236-.165-.354-.247-.456-.243a.303.303 0 00-.225.117C1.001 8.01 1 8.153 1 8.44V15.24c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 001.748 1.748c.485.247 1.002.346 1.564.392C5.29 21 5.954 21 6.758 21h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 001.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-1.206.044-2.01V8.758v-.327c0-.286 0-.428-.063-.51a.303.303 0 00-.224-.116c-.102-.005-.22.078-.456.242L20.4 9.342h-.001z",
    fill: "#475467"
  })));
}

export default SvgMailDark;